import React from 'react'

export default function IconCircle({children}) {
  return (
    < >
      <div className='iconcircle'>{children} </div>  
    </ >
  )
}
